import { useEffect, useState } from 'react';

export const useMobileSize = () => {
  // Lazy-init from the real viewport so the first render doesn't briefly assume desktop.
  const [mobile, setMobile] = useState(
    () => typeof window !== 'undefined' && window.innerWidth < 768,
  );

  const checkMobile = () => {
    const isMobile = window.innerWidth < 768;
    setMobile(isMobile);
  };

  useEffect(() => {
    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => window.removeEventListener('resize', checkMobile);
  });

  return {
    mobile,
  };
};
